// app/javascript/controllers/markers_controller.js
// Toggle transversal markers into a hidden input, mirroring category_controller.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["markersLabel", "inputObservationMarkers", "markerItem"]

  connect() {
    this.markers = this.markersLabelTarget.dataset.markers.split(",").filter(Boolean)
    this.forceMarkersValue()
    this.checkMarkers()
  }

  checkMarkers() {
    this.markerItemTargets.forEach((item) => {
      this.setActive(item, this.markers.includes(item.textContent.trim()))
    });
  }

  toggleMarker(event) {
    if (event.type === "keydown") {
      if (event.key !== "Enter" && event.key !== " ") return
      event.preventDefault()
    }

    const markerLabel = event.currentTarget
    const marker = markerLabel.textContent.trim()

    if (markerLabel.classList.contains("is-active")) {
      this.setActive(markerLabel, false)
      const index = this.markers.indexOf(marker)
      if (index > -1) {
        this.markers.splice(index, 1);
      }
    } else {
      this.setActive(markerLabel, true)
      this.markers.push(marker)
    }
    this.forceMarkersValue()
  }

  setActive(item, active) {
    item.classList.toggle("is-active", active)
    item.setAttribute("aria-pressed", active)
  }

  forceMarkersValue() {
    this.inputObservationMarkersTarget.value = this.markers.join(",")
  }
}
